import { clsx } from "clsx";
import type { ButtonHTMLAttributes, ReactNode } from "react";

import { Spinner } from "@/shared/ui/Spinner";

import cls from "./ActionBtn.module.scss";

interface ActionBtnProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  isBusy?: boolean;
  children?: ReactNode;
  size?: "S" | "M";
  variant?: "magenta" | "navy";
}

export const ActionBtn = (props: ActionBtnProps) => {
  const { className, isBusy = false, children, size = "M", variant = "magenta", ...restProps } = props;

  return (
    <button
      className={clsx(cls.ActionBtn, [
        cls[`size${size}`],
        variant === "navy" && cls.navy,
        className,
        isBusy && cls.isBusy,
      ])}
      {...restProps}
    >
      {isBusy && <Spinner className={cls.Spinner} />}
      <span>{children}</span>
    </button>
  );
};
